<template>
  <div>
    <div class="input-box">
      <span class="prefix" v-if="this.field.metadata.prefix">
        {{ this.field.metadata.prefix }}
      </span>
      <input
        :type="getInputType()"
        :name="this.field.metadata.fieldName"
        :value="getDefaultValue()"
        :readonly="this.field.metadata.readOnlyIfHasValue"
        placeholder=" "
        :required="this.field.metadata.required"
        :minlength="this.field.metadata.minLength"
        :maxlength="this.field.metadata.maxLength"
      />
      <div class="input-label">
        {{ this.field.metadata.label }}
        <span class="required" v-if="this.field.metadata.required">*</span>
      </div>
    </div>
    <br />
    <div class="hint" v-if="this.field.metadata.hint">
      <span v-html="this.field.metadata.hint"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormInputText",
  props: {
    field: {
      type: Object,
    },
  },
  methods: {
    getInputType: function () {
      if (!this.field.metadata.inputType) {
        return "text";
      }
      return this.field.metadata.inputType;
    },
    getDefaultValue: function () {
      if (this.field.metadata.defaultValue) {
        return this.field.metadata.defaultValue;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.input-box {
  border: 1px solid #767676;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.prefix {
  pointer-events: none;
  color: rgba(0,0,0,.46);
  font-size: 14px;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.hint {
  color: #8a8a8a;
  margin-left: 5px;
  margin-top: 5px;
}

.hint >>> * {
  margin-top: 0;
  margin-bottom: 0;
}

.required {
  color: #f00;
}
</style>